module.exports = __webpack_public_path__ + "b3c8857a6a3b30b2e58f57965df63442.pdf";